<template>
  <v-card flat height="100%">
    <v-card-title>
      <v-layout>
        <v-flex xs8 ma-2>ASV-Teams</v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2 ma-2>
          <v-btn block color="primary" @click="back">Zurück</v-btn>
        </v-flex>
        <v-flex xs2 ma-2>
          <v-btn block color="primary" @click="forward">Weiter</v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 md12 lg6 pa-1>
          <v-data-table
            :headers="headers"
            :items="teams"
            :sort-by="['name']"
            :sort-desc="[false]"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:item.action="{ item }">
              <v-icon class="pa-1" @click="edit(item)">mdi-pencil</v-icon>
              <v-icon class="pa-1" @click="remove(item)" v-if="!item.lizenzaenderung">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md12 lg6 pa-1>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs12 sm6 md6 pa-1>
                <v-text-field
                  v-model="edited.nummer"
                  label="Nummer"
                  :rules="rules.nummer"
                  counter="9"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-1>
                <v-text-field v-model="edited.name" label="Name" :rules="rules.name" counter="64"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-spacer></v-spacer>
              <v-btn class="ma-2" color="error" @click="clear">Bearbeitung abbrechen</v-btn>
              <v-btn class="ma-2" color="primary" @click="save">Speichern</v-btn>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
      <v-dialog v-model="deleteDialog" max-width="400">
        <v-card>
          <v-card-title class="headline">Wollen Sie diesen Eintrag wirklich löschen?</v-card-title>
          <v-card-text>Das Löschen kann nicht wieder rückgängig gemacht werden</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="deleteDialog = false">Abbrechen</v-btn>
            <v-btn color="blue darken-1" text @click="deleteTeam">Löschen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
function edited() {
  return {
    teamId: "",
    nummer: "",
    name: ""
  };
}
export default {
  data() {
    return {
      valid: false,
      deleteDialog: false,
      deleteItem: null,
      headers: [
        { text: "Team-ID", value: "teamId" },
        { text: "Nummer", value: "nummer" },
        { text: "Name", value: "name" },
        { text: "Aktionen", value: "action", sortable: false }
      ],
      edited: edited(),
      rules: {
        nummer: [
          v => !!v || "Die Nummer darf nicht leer sein",
          v =>
            new RegExp("00\\d{7}").test(v) ||
            "Die Nummer muss das Format 00nnnnnnn haben."
        ],
        name: [
          v => !!v || "Der Name darf nicht leer sein",
          v => v.length <= 64 || "Der Name muss kürzer als 64 Zeichen sein"
        ]
      }
    };
  },
  computed: {
    ...mapState({
      teams: state => state.current.bestellung.lizenz.asvTeams,
      process: state => state.current.process,
      license: state => state.current.bestellung.lizenz
    })
  },
  mounted: function() {
    if (
      this.$route.params.process != this.process ||
      this.license === undefined
    ) {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.BestellungRequestEvent",
        processId: this.$route.params.process,
        taskId: this.$route.params.task
      });
    }
  },
  watch: {
    teams: function(nV, oV) {
      if (nV !== undefined && nV.length >= oV.length) {
        this.clear();
      }
    }
  },
  methods: {
    edit: function(team) {
      this.edited = JSON.parse(JSON.stringify(team));
    },
    clear: function() {
      this.edited = edited();
      this.$refs.form.resetValidation();
    },
    save: function() {
      if (this.$refs.form.validate()) {
        this.$store.commit("startLoading");
        this.$socket.sendObj({
          eventID:
            "de.t2med.lizenzomat.eventapi.usecase.order.asv.ASVTeamSaveRequestEvent",
          processId: this.$route.params.process,
          taskId: this.$route.params.task,
          asvTeam: this.edited
        });
      }
    },
    remove: function(team) {
      this.deleteItem = team;
      this.deleteDialog = true;
    },
    deleteTeam: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.asv.ASVTeamDeleteRequestEvent",
        asvTeamId: this.deleteItem.id
      });
      this.deleteItem = null;
      this.deleteDialog = false;
    },
    back: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.BackwardRequestEvent",
        taskId: this.$route.params.task,
        processId: this.$route.params.process
      });
    },
    forward: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.asv.ASVTeamContinueRequestEvent",
        taskId: this.$route.params.task,
        processId: this.$route.params.process
      });
    }
  }
};
</script>
